import { cx } from "@emotion/css";
import { forwardRef, ReactNode, useState } from "react";

import { useTheme } from "@/modules/theme/hooks/useTheme";

import {
  InputErrorMessage,
  InputErrorMessageProps,
} from "../ErrorMessage/InputErrorMessage";
import { InputError } from "../InputError/InputError";
import { Label } from "../Label/Label";
import { createTextInputStyles } from "../TextInput/helpers/createTextInputStyles";

import { createTextAreaStyles } from "./helpers/createTextAreaStyles";

type ReactTextAreaProps = React.ComponentProps<"textarea">;
export interface TextAreaProps
  extends ReactTextAreaProps,
    InputErrorMessageProps {
  name: string;
  label?: ReactNode;
  wrapperClassName?: string;
  textAreaClassName?: string;
  showError?: boolean;
}

export const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(
  (
    {
      name,
      onBlur,
      onChange,
      value,
      defaultValue,
      label,
      placeholder,
      disabled = false,
      wrapperClassName,
      textAreaClassName,
      error,
      errorMessages,
      ErrorMessage,
    },
    ref
  ) => {
    const inputClasses = createTextInputStyles(useTheme());
    const classes = createTextAreaStyles();
    const [appliedError, setAppliedError] = useState("");

    const handleErrorChange = (error: string) => {
      setAppliedError(error);
    };

    return (
      <div className={cx(inputClasses.root, wrapperClassName)}>
        {label && <Label htmlFor={name}>{label}</Label>}
        <div
          className={cx(
            inputClasses.wrapper,
            classes.textAreaWrapper,
            wrapperClassName,
            appliedError
              ? inputClasses.wrapperError
              : inputClasses.wrapperRegular,
            { [inputClasses.disabled]: disabled }
          )}
        >
          <textarea
            ref={ref}
            id={name}
            name={name}
            onBlur={onBlur}
            onChange={onChange}
            className={cx(
              inputClasses.input,
              classes.textArea,
              textAreaClassName,
              appliedError && inputClasses.error
            )}
            value={value}
            placeholder={placeholder}
            disabled={disabled}
            defaultValue={defaultValue}
          />
        </div>
        <InputError>
          <InputErrorMessage
            error={error}
            errorMessages={errorMessages}
            ErrorMessage={ErrorMessage}
            name={name}
            onErrorChange={handleErrorChange}
          />
        </InputError>
      </div>
    );
  }
);
